// src/components/CategorySlider.jsx
import React, { useState, useRef, useContext } from "react";
import { ProductsContext } from "../components/ProductsContext"; // ✅ import context
import InquiryModal from "./InquiryModal";
import "../style/CategoryPage.css"; 
import "../style/CategorySlider.css";

const CategorySlider = ({ categoryName, bannerWeb, bannerMobile }) => {  
  const allProducts = useContext(ProductsContext); // ✅ get products from context
  const [inquiryProduct, setInquiryProduct] = useState(null);
  const sliderRef = useRef(null);

  // ✅ Filter only products for this category
  const products = allProducts.filter(
    (product) => product.category === categoryName
  );

  const scroll = (dir) => {
    if (sliderRef.current) {
      const cardWidth = sliderRef.current.firstChild?.offsetWidth || 280;
      sliderRef.current.scrollBy({
        left: dir === "left" ? -cardWidth * 2 : cardWidth * 2,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="slider-section">
      <div className="slider-header">
        <h2>{categoryName}</h2>
        <a href={`/category/${categoryName}`} className="shop-all">
          View All →
        </a>
      </div>

      <div className="slider-layout">
        {/* ✅ Left Banner */}
        {(bannerWeb || bannerMobile) && (
          <div className="slider-banner">
            <picture>
              {bannerMobile && (
                <source media="(max-width: 768px)" srcSet={bannerMobile} />
              )}
              {bannerWeb && (
                <img src={bannerWeb} alt={`${categoryName} banner`} />
              )}
            </picture>
          </div>
        )}

        {/* ✅ Right Product Slider */}
        <div className="slider-wrapper">
          <button className="slider-arrow left" onClick={() => scroll("left")}>
            {"<"}
          </button>

          <div className="slider-container" ref={sliderRef}>
            {products.map((product) => (
              <div
                className="product-card"
                key={product.id}
                id={`slider-product-${product.id}`}
              >
                {product.discount > 0 && (
                  <span className="discount-badge">
                    {product.discount}% OFF
                  </span>
                )}
                <img src={product.img} alt={product.title} />
                <h4>{product.title}</h4>
                <p className="brand">{product.brand}</p>
                <p className="mrp">₹{product.mrp?.toLocaleString()}</p>
                <p className="price">₹{product.price?.toLocaleString()}</p>
                <p className={`stock ${product.stock ? "in" : "out"}`}>
                  {product.stock ? "In Stock" : "Out of Stock"}
                </p>
                <button
                  className="buy-btn"
                  onClick={() => setInquiryProduct(product)}
                >
                  Inquire Now
                </button>
              </div>
            ))}
          </div>

          <button className="slider-arrow right" onClick={() => scroll("right")}>
            {">"}
          </button>
        </div>
      </div>

      {/* ✅ Inquiry Modal (unchanged) */}
      <InquiryModal
        isOpen={!!inquiryProduct}
        onClose={() => setInquiryProduct(null)}
        product={inquiryProduct}
      />
    </div>
  );
};

export default CategorySlider;
